export const sanitiseInternalFieldName = (value: string) => {
  return value.replace(RegExp("[^a-zA-Z0-9_-]", "g"), "");
};
